import { defineComponent as $, mergeModels as f, useModel as x, ref as L, watch as M, onBeforeMount as B, openBlock as n, createElementBlock as k, normalizeClass as s, createElementVNode as r, unref as a, withModifiers as o, createCommentVNode as p, createVNode as F, nextTick as z } from "vue";
import E from "./BaseFloatingLabel.js";
import { useFloatingLabel as I } from "./useFloatingLabel.js";
import { _ as C } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseTextarea.css';const H = ["id", "data-cy", "rows", "disabled", "aria-labelledby", "readonly", "value"], q = {
  key: 0,
  class: "uikit-visible uikit-float-none uikit-ml-2 uikit-block uikit-h-3 uikit-w-auto uikit-max-w-full uikit-overflow-hidden uikit-whitespace-nowrap uikit-p-0 uikit-text uikit-duration-[50s] uikit-ease-out"
}, A = ["innerHTML"], N = ["innerHTML"], D = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "BaseTextarea",
  props: /* @__PURE__ */ f({
    labelText: { default: "" },
    feedback: {},
    isValid: { default: null },
    resize: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ f(["focusin", "focusout", "keydown"], ["update:modelValue"]),
  setup(v, { expose: m, emit: c }) {
    const u = x(v, "modelValue"), b = c, {
      labelState: t,
      setInitialLabelState: w,
      handleFocusIn: g,
      handleFocusOut: y,
      setFloatingLabel: V,
      setInlineLabel: T
    } = I(b), i = L(null);
    M(u, (e) => {
      `${e}`.length && t.value !== "floating-label" ? V() : !e?.length && t.value !== "inline-label" && document.activeElement !== i.value && T();
    }), B(() => {
      w(u.value);
    });
    const h = ({ target: e }) => {
      u.value = e.value;
    };
    return m({
      disableTextarea: () => {
        i.value && (i.value.setAttribute("readonly", "readonly"), i.value.classList.add("disabled"));
      },
      clearTextareaElem: () => {
        i.value && (i.value.value = "");
      },
      focusDisabledTextarea: () => {
        i.value && (i.value.removeAttribute("readonly"), i.value.classList.remove("disabled"), z(() => {
          i.value && i.value.focus();
        }));
      }
    }), (e, l) => (n(), k("div", {
      class: s(e.$attrs["wrapper-classes"])
    }, [
      r("div", {
        class: s(["input-wrapper uikit-relative uikit-rounded-xs uikit-px-0", [
          a(t) === "floating-label" ? "floating-state" : "inline-state"
        ]])
      }, [
        r("textarea", {
          id: e.$attrs.id,
          ref_key: "textarea",
          ref: i,
          "data-cy": e.$attrs["data-cy"],
          class: s(["textarea-scrollbar uikit-peer/fieldset uikit-relative uikit-z-20 uikit-mb-10px uikit-mt-15px uikit-w-[calc(100%-1px)] uikit-overflow-y-auto uikit-whitespace-pre-wrap uikit-rounded-xs uikit-border-0 uikit-bg-transparent uikit-bg-no-repeat uikit-px-15px uikit-pb-[8px] uikit-outline-none", [
            { "is-invalid invalid-bg !uikit-pr-10": e.isValid === !1 },
            { "is-valid valid-bg !uikit-pr-10": e.isValid },
            { "uikit-resize-none": !e.resize },
            e.$attrs.class
          ]]),
          rows: e.$attrs.rows,
          disabled: e.$attrs.disabled,
          "aria-labelledby": e.$attrs.id,
          readonly: e.$attrs.readonly,
          onFocusin: l[0] || (l[0] = o((d) => a(g)(), ["stop"])),
          onFocusout: l[1] || (l[1] = o((d) => a(y)(`${u.value}`.trim()), ["stop"])),
          onInput: o(h, ["stop"]),
          onKeydown: l[2] || (l[2] = o((d) => b("keydown", d), ["stop"])),
          value: u.value
        }, null, 42, H),
        r("fieldset", {
          class: s(["uikit-pointer-events-none uikit-absolute -uikit-top-0 uikit-bottom-[3px] uikit-left-0 uikit-right-0 uikit-m-0 uikit-min-w-0 uikit-overflow-hidden uikit-rounded-xs uikit-border uikit-border-solid uikit-bg-white uikit-p-0 uikit-px-2 uikit-text-start uikit-transition-[border] uikit-duration-100 uikit-ease-out peer-focus/fieldset:uikit-border-2 peer-focus/fieldset:uikit-border-w-primary peer-disabled/fieldset:uikit-bg-w-cultured peer-[&.disabled]/fieldset:uikit-bg-w-cultured peer-focus/fieldset:[&.is-invalid]:uikit-border-w-danger", [
            { "is-invalid": e.isValid === !1, "is-valid": e.isValid },
            { "uikit-border-w-danger": e.isValid === !1 },
            { "uikit-border-w-primary": e.isValid },
            { "uikit-border-w-secondary": e.isValid === null }
          ]])
        }, [
          e.labelText ? (n(), k("legend", q, [
            r("span", {
              class: s(["uikit-px-5px uikit-opacity-0", [
                {
                  "uikit-visible uikit-inline-block": a(t) === "floating-label"
                },
                {
                  "uikit-invisible uikit-hidden": a(t) === "inline-label"
                }
              ]]),
              innerHTML: e.labelText
            }, null, 10, A)
          ])) : p("", !0)
        ], 2),
        F(E, {
          for: e.$attrs.id,
          "label-text": e.labelText,
          "label-state": a(t),
          required: e.$attrs.required,
          "is-valid": e.isValid,
          "label-classes": [
            a(t) === "floating-label" ? "!-uikit-top-1" : "!uikit-top-4",
            e.$attrs["label-classes"]
          ]
        }, null, 8, ["for", "label-text", "label-state", "required", "is-valid", "label-classes"])
      ], 2),
      (e.isValid || e.isValid === !1) && e.feedback ? (n(), k("div", {
        key: 0,
        class: s(
          e.isValid === !1 ? "uikit-mt-1 uikit-text-12 uikit-text-w-danger" : "uikit-mt-1 uikit-text-12 uikit-text-w-primary"
        ),
        innerHTML: e.isValid === !1 ? e.feedback.invalid : e.feedback.valid
      }, null, 10, N)) : p("", !0)
    ], 2));
  }
}), Q = /* @__PURE__ */ C(D, [["__scopeId", "data-v-464d61f2"]]);
export {
  Q as default
};
